import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=fa074c72&lang=pug&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports